import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { TransferService } from '../../../_provider/transfer.service';
import { IonContent, ModalController, NavParams, PopoverController } from '@ionic/angular';
import { CrmService } from '../../../_provider/crm.service';
import { HttpFunctionResult } from '../../../_interfaces/HttpFunctionResult';
import { Address, AddressBase } from '../../../_interfaces/address';
import { DarkmodeService } from '../../../_provider/darkmode.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { ArrowKeysOptions } from 'src/app/_directives/ArrowKeysUseable.directive';
import { GeneralService } from 'src/app/_provider/general.service';
import { CrmEditPage } from 'src/app/_pages/crm/crm-edit/crm-edit.page';
import { CrmDetailPagePage } from 'src/app/_pages/crm-detail-page/crm-detail-page.page';
export interface Kunde{
  id?: number
  nummer?: string
  bezeichnung?: string
  art?: string
}

@Component({
  selector: 'app-kunden-popover',
  templateUrl: './kunden-popover.page.html',
  styleUrls: ['./kunden-popover.page.scss'],
})
export class KundenPopoverPage implements OnInit {

  public filterValue: string = ""
  // public selectedItem: number = 0
  public loading: boolean = true
  public loadingCount = new Array(8)

  @ViewChild('search', {static: true}) searchElement: ElementRef;
  @ViewChild(IonContent, {static: true}) public contentRef: IonContent;

  public arrowKeysOptions: ArrowKeysOptions = {
    selectedItem: -1,
    mouseOverItem: new EventEmitter<number>(null),
    mouseMove: new EventEmitter<boolean>(null),
    enterPressed: (index: number) =>{
      this.select(this.addresses[index])
    }
  }


  public addresses: AddressBase[] = []
  public type: "modal" | "popover"

  constructor(
    private transfer: TransferService, 
    private crmSrv: CrmService,
    private modalCtrl: ModalController,
    public darkmode: DarkmodeService,
    public general: GeneralService,
    private feedback: FeedbackService,
    private changeDetector: ChangeDetectorRef,
    private navParams: NavParams,
    private popover: PopoverController) {
  }

  async ngOnInit() {
    this.type = this.navParams.get<"modal" | "popover">("type")
    await this.search()
  }

  ionViewDidEnter(){
    this.arrowKeysOptions.ionContent = this.contentRef
    setTimeout(() => {
      this.searchElement.nativeElement.focus();
    }, 100);
  }

  async select(kunde: AddressBase){
    
    this.transfer.setVALUE(kunde)
    await this.feedback.hideKeyboardOnIOS()
    if(this.type == "popover") await this.popover.dismiss()
    else await this.modalCtrl.dismiss()

  }

  private timeout
  setFilter(event: KeyboardEvent){
    const isArrow: boolean = event.key == "ArrowUp" || event.key == "ArrowDown" || event.key == "Enter"
    if(isArrow) return
    this.loading = true
    clearTimeout(this.timeout)
    this.timeout = setTimeout(async () => {
      await this.search()
      if(this.addresses.length > 0) this.arrowKeysOptions.selectedItem = 0
      else this.arrowKeysOptions.selectedItem = -1
    }, 300); 
  }

  private async search(){
    let crms: HttpFunctionResult<AddressBase[]> = await this.crmSrv.getBasicCrmList(this.filterValue)
    if(crms.success){
      this.addresses = crms.data
      this.changeDetector.detectChanges()
    }
    this.loading = false
  }

  public async addCrm(){
    await this.feedback.openModal(CrmEditPage, {isNew: true}, async (result: HttpFunctionResult<Address>)=>{
      if(!result.success) return
      this.addresses.unshift(result.data)
    })
  }


  public async close(){
    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss()
  }

  public async openAddressDetails(event: Event, address: AddressBase){
    event.stopPropagation()
    this.general.setActiveCrm(address)
    await this.feedback.openModal<any>(CrmDetailPagePage, {isModal: true})
  }

}
